import { render, staticRenderFns } from "./UI-modal-notification.vue?vue&type=template&id=633acec1&"
import script from "./UI-modal-notification.vue?vue&type=script&lang=js&"
export * from "./UI-modal-notification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports